module.exports = __webpack_public_path__ + "img/b3c7010.jpg";